"use client";

import React, { useState } from "react";
import { classNames } from "@/utils";
import { SupChevronRight } from "@repo/core-ui";

interface FaqSectionProps {
  title: string;
  content: string;
}

export default function FaqSection({ title, content }: FaqSectionProps) {
  const [show, setShow] = useState<boolean>(false);
  return (
    <div className="relative mx-2 items-center gap-4 border-b-[0.5px] border-[#404040] font-mono text-base tracking-wider transition-all duration-[800] last:border-b-[0px]">
      <div className="flex w-full items-center py-4 hover:cursor-pointer hover:opacity-60" onClick={() => setShow(!show)}>
        <SupChevronRight className={classNames("transform transition-transform", show ? "rotate-90" : "rotate-0")} />
        <p className="pl-4 text-xs leading-3">{title}</p>
      </div>
      <div className={classNames("relative transition-all duration-500 ease-in-out", show ? "opacity-1 top-0" : "top-[-30px] max-h-0 overflow-hidden opacity-0")}>
        <p className="p-4 text-base">{content}</p>
      </div>
    </div>
  );
}
